import { render, staticRenderFns } from "./Orden.vue?vue&type=template&id=e642247a&scoped=true"
import script from "./Orden.vue?vue&type=script&lang=js"
export * from "./Orden.vue?vue&type=script&lang=js"
import style0 from "./Orden.vue?vue&type=style&index=0&id=e642247a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e642247a",
  null
  
)

export default component.exports